export default __webpack_public_path__ + "static/media/icon-promoter.c741c57d.svg";